import React, { useEffect, useState } from "react";
import { Droplets } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { LABELS, fmtDateTime } from "@/components/trailCondition";

/* Transparency strip: last rainfall check, 6h/24h totals, thresholds, staleness + disclaimer. */
export default function ConditionsMeta({ className = "" }) {
    const { lang } = useLang();
    const en = lang === "en";
    const L = LABELS[en ? "en" : "it"];
    const [m, setM] = useState(null);

    useEffect(() => {
        api.get("/trail-conditions/status").then((r) => setM(r.data)).catch(() => setM({ stale: true }));
    }, []);

    if (!m) return null;
    const thr = m.thresholds || {};
    const last = fmtDateTime(m.last_success_at, lang);
    const hoursSince = m.last_success_at ? Math.round((Date.now() - new Date(m.last_success_at).getTime()) / 3600000) : null;

    return (
        <div data-testid="conditions-meta" className={`border border-white/10 bg-abnormal-charcoal px-4 py-3 text-xs leading-snug ${className}`}>
            <div className="flex flex-wrap items-center gap-x-4 gap-y-1 label-mono">
                <span className="inline-flex items-center gap-1.5 text-abnormal-paper"><Droplets size={12} className="text-abnormal-acid" /> {en ? "RAINFALL ARGENTARIO" : "PIOGGIA ARGENTARIO"}</span>
                {last ? (
                    <>
                        <span className="text-abnormal-paperDim">24h: <b className="text-abnormal-paper">{m.mm_24h} mm</b> · 6h: <b className="text-abnormal-paper">{m.mm_6h} mm</b></span>
                        <span className="text-abnormal-paperDim/70">{en ? "thresholds" : "soglie"} {thr.wet_mm_24h} mm/24h · {thr.wet_mm_6h} mm/6h</span>
                        <span className="text-abnormal-paperDim/70">{en ? "checked" : "controllo"} {last}</span>
                    </>
                ) : (
                    <span className="text-abnormal-paperDim">{en ? "no rainfall check yet" : "nessun controllo pioggia ancora eseguito"}</span>
                )}
                {m.stale && last && (
                    <span data-testid="conditions-stale" className="text-abnormal-warn">{L.stale} {hoursSince} {L.hours}</span>
                )}
            </div>
            <p className="mt-1.5 text-abnormal-paperDim/70">{L.disclaimer}</p>
        </div>
    );
}
